import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

type FileTypeIconProps = Omit<React.SVGProps<SVGSVGElement>, "type"> & {
  /**
   * File type ("pdf", ".pdf") or a file name ("report.pdf"); the part after
   * the last dot is rendered uppercased in the badge. No label is drawn when omitted.
   */
  type?: string;
};

const DARK_COLOR = "#191A1C";
const LIGHT_COLOR = "#FFFFFF";

const FileTypeIcon: React.FC<FileTypeIconProps> = ({ type, fill, style, ...props }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const customFill = fill?.trim();
  const finalColor = customFill || (isDarkMode ? LIGHT_COLOR : DARK_COLOR);
  // The label sits on the filled badge, so it only goes dark when the badge
  // is the default dark-mode white.
  const labelColor = !customFill && isDarkMode ? DARK_COLOR : LIGHT_COLOR;

  const label = type?.split(".").pop()?.toUpperCase();

  return (
    <svg
      width="357"
      height="386"
      viewBox="13 0 357 386"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor, ...style }}
      {...props}
    >
      <path
        d="M84.4391 21.1094H253.317L348.311 116.103V364.143H84.4391V21.1094Z"
        stroke="currentColor"
        strokeWidth="26.3872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M253.317 21.1094V116.103H348.311"
        stroke="currentColor"
        strokeWidth="26.3872"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M295.537 184.711H31.6648C25.8355 184.711 21.1099 189.437 21.1099 195.266V300.815C21.1099 306.644 25.8355 311.369 31.6648 311.369H295.537C301.367 311.369 306.092 306.644 306.092 300.815V195.266C306.092 189.437 301.367 184.711 295.537 184.711Z"
        fill="currentColor"
      />
      {label && (
        <text
          x="163.5"
          y="252.5"
          fill={labelColor}
          fontFamily="Arial, sans-serif"
          fontSize="65"
          fontWeight="400"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {label}
        </text>
      )}
    </svg>
  );
};

export default FileTypeIcon;
